module.exports = __webpack_public_path__ + "static/media/email.d099f9b3.png";